// Cliente HTTP da Etapa 6. As etapas anteriores não foram alteradas.
import { configureFolhaApiEtapa5 } from '../etapa5/api'

let config = {
  baseUrl: '/api/v1' /* URL definida por configureFolhaApiEtapa6 (integração FSC) */,
  getHeaders: async () => ({}),
}

export function configureApiEtapa6({ baseUrl, getHeaders } = {}) {
  config = { baseUrl: baseUrl ?? config.baseUrl, getHeaders: getHeaders ?? config.getHeaders }
}

// Configura os clientes das Etapas 1 a 6 de uma vez.
export function configureFolhaApiEtapa6(opcoes = {}) {
  configureFolhaApiEtapa5(opcoes)
  configureApiEtapa6(opcoes)
}

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json', ...(await config.getHeaders()) }
  const resp = await fetch(`${config.baseUrl}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const detail = data?.detail
    const msg = Array.isArray(detail) ? detail.map((d) => `${d.loc?.slice(-1)[0] ?? ''}: ${d.msg}`).join('; ') : detail || resp.statusText
    const erro = new Error(msg)
    erro.status = resp.status
    throw erro
  }
  return data
}

const enc = encodeURIComponent

export const apiEtapa6 = {
  jornadaVigente: (data) => request('GET', `/jornada/vigente?data=${enc(data)}`),
  jornadaEmpresa: (empresaId) => request('GET', `/jornada/empresas/${enc(empresaId)}`),
  salvarJornadaEmpresa: (empresaId, d) => request('PUT', `/jornada/empresas/${enc(empresaId)}`, d),
  jornadaFuncionario: (empresaId, id) => request('GET', `/jornada/funcionarios/${enc(empresaId)}/${enc(id)}`),
  salvarJornadaFuncionario: (empresaId, id, d) => request('PUT', `/jornada/funcionarios/${enc(empresaId)}/${enc(id)}`, d),
  simularFolha: (e) => request('POST', '/folha-mensal/simular', e),
  calcularFolha: (e) => request('POST', '/folha-mensal/calcular', e),
  enfileirarFolha: (e) => request('POST', '/folha-mensal/lotes', e),
  afastamentos: (empresaId, id) => request('GET', `/afastamentos/${enc(empresaId)}/${enc(id)}`),
  registrarAfastamento: (empresaId, id, d) => request('POST', `/afastamentos/${enc(empresaId)}/${enc(id)}`, d),
  encerrarAfastamento: (empresaId, id, afId, fim) => request('PUT', `/afastamentos/${enc(empresaId)}/${enc(id)}/${enc(afId)}/fim`, { fim }),
  excluirAfastamento: (empresaId, id, afId) => request('DELETE', `/afastamentos/${enc(empresaId)}/${enc(id)}/${enc(afId)}`),
  s2230: (empresaId, id, afId) => request('GET', `/afastamentos/${enc(empresaId)}/${enc(id)}/${enc(afId)}/s2230`),
  impactos: (empresaId, id, ano, pa) =>
    request('GET', `/afastamentos/${enc(empresaId)}/${enc(id)}/impactos?ano=${enc(ano)}${pa ? `&periodo_aquisitivo_inicio=${enc(pa)}` : ''}`),
  viradaAno: (ano) => request('GET', `/sistema/virada-ano/${enc(ano)}`),
  sistema: () => request('GET', '/sistema/etapa'),
}
